import React from 'react'
import { Link } from 'react-router-dom'

import './safariImageBox.css'

const safariImageBox = ({imgSrc, text, to}) => {
  return <div className='wildlife__safari-card e'>
    <Link to={to}>
    <img className='wildlife__safari-card-image' src={imgSrc} alt="" />
    </Link>
    <Link to={to} className='wildlife__safari-link'>
    <h2 className='wildlife__safari-card-text'>{text}</h2>
    </Link>
  </div>
}

export default safariImageBox